import React, { useState, useEffect, useCallback, useContext } from "react";
import axios from "axios";
import { NotificationManager } from "react-notifications";
import _ from "lodash";
import styled from "styled-components";
import Divider from "@mui/material/Divider";
import { ActionContext } from "context/ActionContext";
import { ActionPlansContext } from "context/ActionPlansContext";
import UserService from "services/UserService";
import {
  putAction,
  getAction,
  getSite,
  postActionImpact,
} from "services/ConfigServices";
import { action as actionVar } from "variables/action";
import {
  energyType,
  unityTypeData,
  unitycountTypeData,
  unitcostData,
  targetedenergyList,
  targetedusageList,
  savingstypeData,
  savingscalculationData,
} from "variables/lists/action";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import {
  MultiselectCheckbox,
  CustomSelect,
  IntInput,
} from "components/Input/Index.js";
import ButtonGroups from "components/Ui/Buttons/ButtonGroups";
import EditButton from "components/CustomButtons/EditButton";
import RTMetersContracts from "./Meters/Associatedcontracts/RTMetersContracts";
import RTMetersPowersPerimeter from "./Meters/TurpeOptimization/RTMetersPowersPerimeter";
import optimizationResults from "utilities/fonctionscontrat.js";

const SubTitle = styled.div`
  margin: ${(props) =>
    props.first ? "1rem 0rem 0.1rem 1.4rem" : "1.4rem 0rem 0.1rem 1.4rem"};
  font-size: 1.2rem;
  font-weight: 500;
  text-underline-position: under;
  text-decoration: underline;
  text-decoration-color: #91c73c;
`;

const ResultTitle = styled.div`
  margin-bottom: 0.8rem;
  font-size: 1rem;
  font-weight: 500;
  opacity: 0.85;
`;

const ResultData = styled.div`
  font-size: 1.2rem;
  font-weight: 500;
`;

export default function Market({ apiData, params, closeModal }) {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const appContext = useContext(ActionContext);
  const { action, setAction } = appContext;
  const plansContext = useContext(ActionPlansContext);
  const { actionPlans, setActionPlans } = plansContext;
  const [isRefetched, setIsRefetched] = useState(0);

  const [newParameters, setNewParameters] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        [params]: { ...prevState.parameters[params], [name]: value },
      },
    }));
  };
  const handleEnergyChange = (e) => {
    const { name, value } = e.target;
    console.log(value);
    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,       
        [params]: { 
          mode: "simple", 
          [name]: value, 
          targetedenergy: [{id:value, name:targetedenergyList.find((obj)=>obj.id===value).name}]},
      },
    }));
  };

  useEffect(() => {
    setNewParameters(action?.parameters || {});
  }, [action?.parameters?.impact]);



  let url = putAction(action.id);

  const handleSubmit = (event) => {
    createActionImpact(event);
  };

  const createActionImpact = async (event) => {
    let impactresult;
    action.parameters?.impact?.mode == "simple" ?
      impactresult = {
        totalEarnings,
        totalEvolution,
        totalCo2,
        totalEvolutionCo2,
      } :
      impactresult = {
        totalEarnings: econet.reduce(reducer, 0).toFixed(2),
        totalCost: cost.reduce(reducer, 0).toFixed(2),
        cost,
        ecosous,
        ecodep,
        econet
      };
    let newParams = {
      ...newParameters,
      impact: {
        ...newParameters.impact,
        ...impactresult,
      }
    };
    axios
      .put(
        url,
        {
          ...newParams
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Action modifiée");
          setNewParameters(newParams || {});
          setAction((prevState) => ({
            ...prevState,
            parameters: {
              ...prevState.parameters,
              ...newParams,
            },
          }));
          // getActionData();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleSwitchMode = (mode) => {
    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        impact: {
          //...prevState.parameters?.impact,
          mode,
        },
      },
    }));
  };



  const reducer = (previousValue, currentValue) => previousValue + currentValue;

  let meters = action.parameters?.impact?.meters ?? [];
  let impact = action.parameters?.impact ?? [];

  let cost = impact?.meters?.map((meter) => meter?.details?.cost) ?? [0];
  let ecodep = impact?.meters?.map((meter) => meter?.details?.ecodep) ?? [0];
  let ecosous = impact?.meters?.map((meter) => meter?.details?.ecosous) ?? [0];
  let econet = impact?.meters?.map((meter) => meter?.details?.econet) ?? [0];

 // console.log(impact?.meters);
  
  const {
    totalEarnings,
    totalEvolution,
    totalCo2,
    totalEvolutionCo2,
  } = optimizationResults(meters, impact);

  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <ButtonGroups
            switchMode={action?.parameters?.impact?.mode || ""}
            handleSwitchMode={handleSwitchMode}
            firstButton={"Changement du contrat fournisseur"}
            secondButton={"Optimisation du TURPE"}
            disabled={!actionplanupdate}
          />
        </GridItem>
      </GridContainer>

      {action.parameters?.impact?.mode == "simple" && (
        <>
          <SubTitle>Paramètres considérés</SubTitle>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <CustomSelect
                inputTitle={actionVar[params].energy}
                selectValue={action?.parameters?.[params]?.["energy"] || ""}
                handleSelectValueChange={handleEnergyChange}
                data={targetedenergyList}
                name="energy"
                disabled={!actionplanupdate}
              />
            </GridItem>
          </GridContainer>
          <SubTitle>Compteurs et contrats</SubTitle>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <div
                style={{
                  border: "0.099rem solid rgba(0, 0, 0, .22)",
                  borderRadius: "0.3rem",
                  padding: "0 0.6rem",
                  margin: "1rem 0.5rem 0rem",
                }}
              >
                <RTMetersContracts />
              </div>
            </GridItem>
          </GridContainer>
          <SubTitle>Impacts</SubTitle>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <CustomSelect
                inputTitle={actionVar[params].savingstype}
                selectValue={
                  action?.parameters?.[params]?.["savingstype"] || ""
                }
                handleSelectValueChange={handleChange}
                data={savingstypeData}
                name="savingstype"
                disabled={!actionplanupdate}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-around",
                  padding: "1rem",
                  margin: "0.5rem 0.5rem 2rem",
                  border: "0.099rem solid rgba(0, 0, 0, .22)",
                  borderRadius: "0.3rem",
                }}
              >
                <div>
                  <ResultTitle>Fluide </ResultTitle>
                  <ResultData>
                    {
                      targetedenergyList.find(
                        (e) => e.id == action?.parameters?.[params]?.["energy"]
                      )?.name
                    }
                  </ResultData>
                </div>
                <Divider
                  orientation="vertical"
                  flexItem
                  style={{ margin: "0rem 3rem" }}
                />
                <div>
                  <ResultTitle>Economies projetées (€)</ResultTitle>
                  <ResultData>
                    {new Intl.NumberFormat("fr-FR", {
                      style: "currency",
                      currency: "EUR",
                    }).format(totalEarnings)}
                  </ResultData>
                </div>
                <Divider
                  orientation="vertical"
                  flexItem
                  style={{ margin: "0rem 3rem" }}
                />
                <div>
                  <ResultTitle>% Economies €</ResultTitle>
                  <ResultData>{totalEvolution ?? 0} %</ResultData>
                </div>
                <Divider
                  orientation="vertical"
                  flexItem
                  style={{ margin: "0rem 3rem" }}
                />
                <div>
                  <ResultTitle>Economies CO2 projetées (kg eq CO2)</ResultTitle>
                  <ResultData>{totalCo2}</ResultData>
                </div>
                <Divider
                  orientation="vertical"
                  flexItem
                  style={{ margin: "0rem 3rem" }}
                />
                <div>
                  <ResultTitle>% Economies CO2</ResultTitle>
                  <ResultData>{totalEvolutionCo2 ?? 0} %</ResultData>
                </div>
              </div>
            </GridItem>
          </GridContainer>
        </>
      )}
      {action.parameters?.impact?.mode == "expert" && (
        <>
          <SubTitle>Paramètres considérés</SubTitle>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <div
                style={{
                  border: "0.099rem solid rgba(0, 0, 0, .22)",
                  borderRadius: "0.3rem",
                  padding: "0 0.6rem",
                  margin: "1rem 0.5rem 0rem",
                }}
              >
                <RTMetersPowersPerimeter isRefetched={isRefetched} />
              </div>
            </GridItem>
          </GridContainer>
          <SubTitle>Impacts</SubTitle>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-around",
                  padding: "1rem",
                  margin: "0.5rem 0.5rem 2rem",
                  border: "0.099rem solid rgba(0, 0, 0, .22)",
                  borderRadius: "0.3rem",
                }}
              >
                <div>
                  <ResultTitle>Economie modifications (€)</ResultTitle>
                  <ResultData>
                    {new Intl.NumberFormat("fr-FR", {
                      style: "currency",
                      currency: "EUR",
                    }).format(ecosous.reduce(reducer, 0))}
                  </ResultData>
                </div>
                <Divider
                  orientation="vertical"
                  flexItem
                  style={{ margin: "0rem 3rem" }}
                />
                <div>
                  <ResultTitle>Economie dépassements (€)</ResultTitle>
                  <ResultData>
                    {new Intl.NumberFormat("fr-FR", {
                      style: "currency",
                      currency: "EUR",
                    }).format(ecodep.reduce(reducer, 0))}
                  </ResultData>
                </div>
                <Divider
                  orientation="vertical"
                  flexItem
                  style={{ margin: "0rem 3rem" }}
                />
                <div>
                  <ResultTitle>Coût de variation PS (€)</ResultTitle>
                  <ResultData>
                    {new Intl.NumberFormat("fr-FR", {
                      style: "currency",
                      currency: "EUR",
                    }).format(cost.reduce(reducer, 0))}
                  </ResultData>
                </div>
                <Divider
                  orientation="vertical"
                  flexItem
                  style={{ margin: "0rem 3rem" }}
                />
                <div>
                  <ResultTitle>Economies nettes (€)</ResultTitle>
                  <ResultData>
                    {new Intl.NumberFormat("fr-FR", {
                      style: "currency",
                      currency: "EUR",
                    }).format(econet.reduce(reducer, 0))}
                  </ResultData>
                </div>
              </div>
            </GridItem>
          </GridContainer>
        </>
      )}
      {actionplanupdate && action.parameters?.impact?.mode && (
        <GridContainer  style={{marginTop: "15px",marginLeft: "8px"}}>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <EditButton handleSubmit={handleSubmit}>Modifier</EditButton>
          </GridItem>
        </GridContainer>
      )}
    </>
  );
}
